export type TargetRole = 'web-developer' | 'it-specialist' | 'all';
export type ProjectCategory = 'web-app' | 'full-stack' | 'it-infrastructure' | 'cloud-api';

export interface IProject {
  id: string;
  title: string;
  shortDescription: string;
  fullDescription: string;
  category: ProjectCategory;
  targetRoles: TargetRole[];
  techStack: string[];
  imageUrl: string;
  liveDemoUrl?: string;
  githubUrl?: string;
  features: string[];
  keyHighlights: string[];
}

/**
 * OOP Domain Model for Portfolio Projects
 */
export class Project implements IProject {
  id: string;
  title: string;
  shortDescription: string;
  fullDescription: string;
  category: ProjectCategory;
  targetRoles: TargetRole[];
  techStack: string[];
  imageUrl: string;
  liveDemoUrl?: string;
  githubUrl?: string;
  features: string[];
  keyHighlights: string[];

  constructor(data: IProject) {
    this.id = data.id;
    this.title = data.title;
    this.shortDescription = data.shortDescription;
    this.fullDescription = data.fullDescription;
    this.category = data.category;
    this.targetRoles = data.targetRoles;
    this.techStack = data.techStack;
    this.imageUrl = data.imageUrl;
    this.liveDemoUrl = data.liveDemoUrl;
    this.githubUrl = data.githubUrl;
    this.features = data.features;
    this.keyHighlights = data.keyHighlights;
  }

  public matchesRole(role: TargetRole): boolean {
    if (role === 'all') return true;
    return this.targetRoles.includes(role);
  }

  public matchesCategory(cat: string): boolean {
    if (cat === 'all') return true;
    return this.category === cat;
  }

  public getCategoryLabel(): string {
    switch (this.category) {
      case 'web-app': return 'Frontend Web App';
      case 'full-stack': return 'Full-Stack Platform';
      case 'it-infrastructure': return 'IT Infrastructure';
      case 'cloud-api': return 'Cloud & API System';
      default: return 'Software Project';
    }
  }
}
